import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

function PromptModal({ message, callback }) {
  const [hidden, setHidden] = useState(false);
  const actionConfirmation = (ok) => {
    setHidden(true);
    if (callback !== undefined) {
      callback(ok);
    }
  };

  const dispatchHandler = () => {
    const event = new CustomEvent("onNewServiceWorker", {
      open_progressnote_modal: true,
      open_progressnote_save_modal: true,
    });
    document.dispatchEvent(event);
  };

  const yesConfirmation = () => actionConfirmation(true);

  const noConfirmation = () => {
    actionConfirmation(false);
    dispatchHandler();
  };

  useEffect(() => setHidden(false), [callback]);

  return (
    <Modal show={!hidden} backdrop aria-labelledby="contained-modal-title-vcenter" centered onHide={noConfirmation}>
      <Modal.Body>
        <p className="fw-bolder">{message}</p>
        <div className="mt-3 text-end">
          <Button variant="outline-danger" onClick={yesConfirmation}>
            DISCARD
          </Button>
          <Button className="ml-2" onClick={noConfirmation} variant="success">
            SAVE
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PromptModal;
